export default __webpack_public_path__ + "static/media/mission_vision.b0444cd5.png";